module.exports = "<div class=\"text-center\" style=\"margin-top: 20%;\" >\r\n    <img src=\"assets/img/bachlogo.png\" class=\"w-50 ml-5\" alt=\"e-Billia\">\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/inicio/inicio.component.html
// module id = ./src/app/pages/inicio/inicio.component.html
// module chunks = main